import React, { useState } from "react";
import { Grid, Typography, Modal, ThemeProvider, Box } from "@mui/material";
import { basicTheme } from "../../themes/customTheme";
// import { makeStyles } from "@mui/material/styles";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import FormCard from "../formManagement/formCard";
import OptionalDropDown from "../reusableComponents/OptionalDropDown";

// const useStyles = makeStyles(() => ({
//   closeBtnStyle: {
//     zoom: "2.2",
//     alignItems: "right",
//     color: "#444444",
//     cursor: "pointer",
//     "&:hover": { opacity: 0.7 },
//     maxHeight: "1rem",
//     maxWidth: "1rem",
//   },
// }));
const subGridStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "1.5rem",
  width: "65%",
  maxHeight: "80%",
  overflow: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
  paddingLeft: 5,
  paddingTop: 2,
};

export default function QuestionsListModal({
  openListModal,
  handleClose = () => {},
  questions,
  languages = [],
}) {
  // const classes = useStyles();

  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const handleCloseByClearIcon = () => {
    handleClose();
  };

  const handleChangeLanguage = (event) => {
    setSelectedLanguage(event.target.value);
  };

  return (
    <Modal open={openListModal}>
      <Grid container sx={subGridStyle} spacing={1}>
        <ThemeProvider theme={basicTheme}>
          <Grid item xs={11}></Grid>
          <Grid
            item
            xs={1}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <CloseRoundedIcon
              // className={classes.closeBtnStyle}
              onClick={handleCloseByClearIcon}
            />
          </Grid>
          <Grid item xs={8} marginY={1.5}>
            <Typography
              variant="h4"
              sx={{ color: "#444444", fontWeight: "500" }}
            >
              Questions
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Box
              display="flex"
              alignItems="center"
              bgcolor="#F5F5F5"
              p={2}
              borderRadius={20}
              width="250px"
              height="40px"
              padding="12px 16px"
            >
              <Typography
                sx={{ fontFamily: "Inter", color: "#78828C", marginRight: 2 }}
              >
                Translations
              </Typography>
              <OptionalDropDown
                text={"Translations"}
                id={selectedLanguage}
                handleChange={handleChangeLanguage}
                menuList={languages}
                borderRadius="24px"
                height="100%"
                width="50%"
              />
            </Box>
          </Grid>

          {questions != null &&
            questions.map((item, index) => (
              <FormCard
                index={index}
                key={index}
                view={true}
                question={item}
                selectedLanguage={selectedLanguage}
                setSelectedLanguage={setSelectedLanguage}
              />
            ))}
        </ThemeProvider>
      </Grid>
    </Modal>
  );
}
